
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilter.vue";

  import GET_POSTING_CITIES from "@/apollo/autocomplete-queries/GetPostingCities.gql";
  import DropdownOption from "@/entities/DropdownOption";
  import { Query_RootPostingArgs } from "@/generated/graphql";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      postingCities: {
        query: GET_POSTING_CITIES,
        variables() {
          return this.cityAutocompleteFilter;
        },
        update(data) {
          return data.posting;
        },
        skip() {
          return !this.postingCitySearchString;
        },
      },
    },
  })

  export default class PostingCityMultiselect extends Vue {
    @Prop({required: true, type: Array}) value!: DropdownOption[];
    @Prop({ type: Array, default: () => [] }) country!: string[];
    @Prop({ type: Array, default: () => [] }) state!: string[];
    @Prop({ type: String, default: "Select city" }) placholder!: string;

    postingCities: DropdownOption[] = [];
    postingCitySearchString = "";

    get cityOptions(): DropdownOption[] {
      return this.postingCities;
    }

    get mappedPostingCityValue(): String[] {
      return this.value?.map((item) => item.name);
    }

    get cityAutocompleteFilter():Query_RootPostingArgs {
      const conditions: any[] = [
        {
          city: {
            _ilike: `%${this.postingCitySearchString}%`,
          },
        },
        {
          city: {
            _neq: ""
          }
        }
      ];
      if (this.mappedPostingCityValue.length) {
        conditions.push(
          {
            city: {
              _nin: this.mappedPostingCityValue,
            },
          },
        );
      }

      if (this.country.length) {
        conditions.push({
          country: {
            _in: this.country,
          }
        })
      }

      if (this.state.length) {
        conditions.push({
          state: {
            _in: this.state,
          }
        })
      }
      return {
        where: { _and: conditions },
        limit: 5,
      };
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val);
    }

    handleSearch(val: string) {
      this.postingCitySearchString = val;
    }
  }
